import React from 'react'

import type { Poll } from '../model/Poll'

import { usePollsContext } from './PollsContext'
import { PollOptions } from './PollOptions'
import { PollQuestion } from './PollQuestion'
import { PollVote } from './PollVote'

import './PollBody.scss'

type PollBodyProps = {
  poll: Poll
}

export const PollBody = ({ poll }: PollBodyProps) => {
  const { isVotingAllowed } = usePollsContext()

  const canVote = isVotingAllowed && poll.open

  return (
    <div className="poll-item-component">
      {canVote ? (
        <PollVote poll={poll} />
      ) : (
        <>
          <PollQuestion poll={poll} />
          <PollOptions poll={poll} />
        </>
      )}
    </div>
  )
}
